import { shallowEqual } from 'react-redux';

import { AppState, useAppSelector } from '@redux/store';

export const useChatMessageById = (id: string) =>
  useAppSelector(({ chat }: AppState) => chat.byId[id] || null, shallowEqual);

export const usePinnedChatMessageByShowId = (showId: string) =>
  useAppSelector(
    ({ chat }: AppState) => chat.pinnedByShowId?.[showId] || null,
    shallowEqual,
  );

export const useShowChatMessageIds = (showId: string) =>
  useAppSelector(
    ({ chat }: AppState) => chat.byShowId[showId]?.ids || [],
    shallowEqual,
  );

export const useShowChatMessagesMayLoadMore = (showId: string) =>
  useAppSelector(({ chat }: AppState) =>
    chat.byShowId[showId]?.mayLoadMore !== undefined
      ? chat.byShowId[showId]?.mayLoadMore
      : true,
  );
